import moment from 'moment'
import { prettyUrlParam } from '../../../helpers'

const adminTable = (topic) => {
  return {
    id: topic.id,
    order: topic.order,
    name: topic.name,
    status: topic.is_active ? 'active' : 'inactive',
    items: topic.items,
    created: moment(topic.created_at).unix(),
    updated: moment(topic.updated_at).unix()
  }
}

const clientTable = (topic) => {
  return {
    id: topic.id,
    name: topic.name,
    order: topic.order,
    description: topic.description,
    totalProcedures: topic.total_procedures,
    completedProcedures: topic.completed_procedures ? topic.completed_procedures : 0,
    isCompleted: topic.completed_procedures === topic.total_procedures,
    component: topic.component,
    is_favorite: topic.is_favorite,
    knowledgecheck_id: topic.knowledgecheck_id,
    assigned_knowledgechecks: topic.assigned_knowledgechecks
  }
}

export default {
  set (state) {
    let set = []
    for (const view in state.views) {
      const data = state.views[view].ids.map((id) => state.views[view].index[id])
      set = set.concat(data)
    }

    return set
  },

  view (state) {
    return (view) => {
      const forClient = view === state._clientView || view === state._favoritesView
      const data = state.views[view].ids.map((id) => state.views[view].index[id])
      if (forClient) {
        return data.map(clientTable)
      }
      return data.map(adminTable)
    }
  },

  byPrettyUrlName (state, getters) {
    return (prettyName) => {
      return getters.set.find((topic) => {
        return prettyUrlParam(topic.name) === prettyName
      })
    }
  },

  unsavedChanges (state) {
    const current = state.current
    const formFields = state.forms.update.fields
    let unsaved = false

    if (!current) {
      return unsaved
    }

    if (formFields.name && current.name !== formFields.name) {
      unsaved = true
    }

    if (formFields.description && current.description !== formFields.description) {
      unsaved = true
    }

    if (formFields.active !== null && Number(current.is_active) !== Number(formFields.active)) {
      unsaved = true
    }

    return unsaved
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/topics/getters.js